var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"vx-mask",style:({ 'z-index': _vm.zindex  }),attrs:{"touchmove":"true"},on:{"click":_vm.close}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }